import React, { Component } from 'react'
import {getVerifyEmailSMSOTP,getVerifyCode,getCommonAuthenticatorMethod, getActivateAuthAppUser, getQRCodeForAuthRegistration, getCompanyBrandingList, superAdminLogin, setTranslateLang, getTranslateLang } from '../actions/superAdminLoginAction'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SuperAdminLoginComponent from '../component/superAdminLoginComponent'
import { loggedIn, logOutAdmin, logout } from '../actions/superAdminLoginAction'
import { withRouter } from 'react-router-dom'
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';
import { SignalRBaseUrl,SignalRToken } from '../../Comman/apiEndPoints';
import createConnection from '../../Comman/signalRConnection';
export class SuperAdminLoginContainer extends Component {
    constructor(props) {
        super(props);
        this.props.actions.getCompanyBrandingList();
        this.superAdminLogin = this.superAdminLogin.bind(this)
        this.activateAuthApp = this.activateAuthApp.bind(this)
        this.setCommonAuthenticatorMethod=this.setCommonAuthenticatorMethod.bind(this)
        this.setVerifyEmailSMSOTP=this.setVerifyEmailSMSOTP.bind(this)
        this.setVerifyCode=this.setVerifyCode.bind(this)
        logout();
        this.props.actions.logOutAdmin();
        this.state = {
            currentEvent: 'mainscreen'
        }
    }

    componentWillMount() {
        this.props.actions.getCompanyBrandingList(this.props.dispatch);
        if (loggedIn(this.props.login.authTokenId))
            this.props.history.push('/superadmin/dashboard');
        this.props.actions.getTranslateLang();

    }
    startConnection(userId,token) {
        const newConnection = createConnection(SignalRBaseUrl);

        newConnection.start()
            .then(() => {
               
newConnection.invoke('Login', SignalRToken).then(result => {
          console.log("Invoke successful. Result:", result);
        })
        .catch(err => {
          console.error("Invoke failed:", err);
        });
                 let topicList = [
             'ApproveQRCallBack_USR_' + userId + '_FR',
            'ApproveAuthenticatorCallBack_USR_' + userId + '_FR',
            'RejectAuthenticatorCallBack_USR_' + userId + '_FR'
        ]
        
        console.log('token',SignalRToken)
        console.log('topic',topicList)
        newConnection.invoke('SubscribeToTopics', SignalRToken, topicList) .then(result => {
          console.log("Invoke successful. Result:", result);
        })
        .catch(err => {
          console.error("Invoke failed:", err);
        });
                //this.Login(newConnection,token)
               // this.SubscribeToTopics(userId, token, newConnection)
            })
            .catch(err => console.error('Error starting connection: ', err));

        if (newConnection) {

            newConnection.on('ApproveQRCallBack_USR_' + userId + '_FR', (data) => {
            
                if(this.props.login.loginDetailss)
                this.setToken()      
                if (loggedIn(this.props.login.authTokenId))
                this.props.history.push('/superadmin/dashboard');

            });
            newConnection.on('ApproveAuthenticatorCallBack_USR_' + userId + '_FR', (data) => {
                 
                    if(this.props.login.loginDetailss)
                this.setToken()    
                 if (loggedIn(this.props.login.authTokenId))
                this.props.history.push('/superadmin/dashboard');

            });
             newConnection.on('RejectAuthenticatorCallBack_USR_' + userId + '_FR', (data) => {
                 
                  window.location.reload()

            });

        }

        
    }
    
    SubscribeToTopics(userId, token, newConnection) {

        let topicList = [
             'ApproveQRCallBack_USR_' + userId + '_FR',
            'ApproveAuthenticatorCallBack_USR_' + userId + '_FR',
            'RejectAuthenticatorCallBack_USR_' + userId + '_FR'
        ]
        newConnection.invoke('SubscribeToTopics', token, topicList);
        console.log(topicList)
    }
    Login(newConnection,token) {
        newConnection.invoke('Login', token);
        console.log('loginRSuccessful')
    }
    getCompanyBrandingData1 = () => {
        this.props.actions.getCompanyBrandingList(this.props.dispatch)
    }
    activateAuthApp(data) {

        this.props.actions.getActivateAuthAppUser(data)
        .then(res => {
            console.log('f', res)
           
           if(res.activateAppUserSucceeded==true)
           {   
               let userConfirm=window.confirm('You have Sucessfully activated the authenticator app')
               if(userConfirm)
                window.location.reload()
            else
                window.location.reload()
           }
        })
    }
    setCommonAuthenticatorMethod(data) {

        this.props.actions.getCommonAuthenticatorMethod(data).then(res => {
            if(res.statusCode==200)
            {
                if(res.removeAccountObject.MethodKey==='QR')
                {
                    this.setState({ currentEvent: 'authqr' })
                }
                if(res.removeAccountObject.MethodKey==='AUTHNOTIFY')
                {
                    this.setState({ currentEvent: 'authnotify' })
                }
                 if(res.removeAccountObject.MethodKey==='AUTHOTP')
                {
                    this.setState({ currentEvent: 'authotp' })
                } 
                if(res.removeAccountObject.MethodKey==='OTP')
                {
                    this.setState({ currentEvent: 'eotp' })
                }     
            }
       
           
        })
    }
     setVerifyEmailSMSOTP(data) {

        this.props.actions.getVerifyEmailSMSOTP(data).then(res => {
            if(res.statusCode==200)
            {
                if(this.props.login.loginDetailss)
                this.setToken()
                      if (loggedIn(this.props.login.authTokenId))
                        this.props.history.push('/superadmin/dashboard');
               
                  
            }
              if(res.statusCode==404 || res.errorMessage=="Otp does not match.")
                {   
                   window.alert('Wrong OTP') 
                }
       
           
        })
    }
     setVerifyCode(data) {

        this.props.actions.getVerifyCode(data).then(res => {
            if(res.statusCode==200)
            {
                if(res.isCodeVerified==true)
                {
                        if(this.props.login.loginDetailss)
                this.setToken()
                      if (loggedIn(this.props.login.authTokenId))
                        this.props.history.push('/superadmin/dashboard');
                }
                 if(res.isCodeVerified==false)
                {   
                   window.alert('Wrong OTP') 
                }
                  
                  
            }
       
           
        })
    }
    superAdminLogin(username, password) {
        const { t } = this.props;
        this.props.actions.superAdminLogin(
            username,
            password,
            this.props.dispatch).then(res => {
                console.log('ddd', res)

                if (res.superAdmin.Authentication.AuthType === "Username/Password") {
                    console.log(this.props.login.authTokenId)
                        if(this.props.login.loginDetailss)
                this.setToken()
                    if (loggedIn(this.props.login.authTokenId))
                        this.props.history.push('/superadmin/dashboard');
                    return
                }

                else if (res.superAdmin.IsAuthActive == false) {
                    /* if (res.superAdmin.Method.some((i) => i.AuthMethodKey === 'OTP') && res.superAdmin.Method.length != 0 && res.superAdmin.IsAuthActive == false) {
                        console.log(this.props.login.authTokenId)
                        if (loggedIn(this.props.login.authTokenId))
                            this.props.history.push('/superadmin/dashboard');
                        return
                    } */
                    // else {
                    let data = {
                        UserId: parseInt(res.superAdmin.UserId),
                        EmailId: res.superAdmin.EmailId
                    }
                    this.props.actions.getQRCodeForAuthRegistration(data, this.props.dispatch).then(res => {
                        
                        this.setState({ currentEvent: 'addauthenticator' })
                    }).catch(err => {
                        debugger
                        console.log("error", err);
                        swal({
                            text: `${t('Login.Username and Password is not correct')}`,
                            icon: "error",
                        });
                    })
                    // }






                }
                else if(res.superAdmin.IsAuthActive == true)
                {
                    this.startConnection(res.superAdmin.UserId,res.authToken);
                    this.setState({currentEvent:'signInOptions'})
                }
              
               /*   else if(res.superAdmin.IsAuthActive == false && res.superAdmin.Method.some((e)=>e.AuthMethodKey==='OTP'))
                {
                    if(this.props.login.loginDetailss)
                this.setToken()
                    if (loggedIn(this.props.login.authTokenId))
                        this.props.history.push('/superadmin/dashboard');
                    return
                } */

            })
            .catch(err => {
              
                console.log("error", err);
                swal({
                    text: `${t('Login.Username and Password is not correct')}`,
                    icon: "error",
                });
            })
    }
    setLanguage = (lang) => {
        this.props.actions.setTranslateLang(
            lang,
            this.props.dispatch
        )
    }
             setToken() {
    
    // Saves user token to localStorage
    sessionStorage.setItem('id_super_admin_token', this.props.login.authTokenId);
    sessionStorage.setItem('SuperAdminUserID', this.props.login.loginDetailss.UserId);
    sessionStorage.setItem('SuperAdminUserName', this.props.login.loginDetailss.FirstName+' '+this.props.login.loginDetailss.LastName);
    sessionStorage.setItem('OrganizationId', this.props.login.loginDetailss.OrganizationId);
    sessionStorage.setItem('Permissions', JSON.stringify(this.props.login.loginDetailss.rolePermission));
    sessionStorage.setItem('UserType', this.props.login.loginDetailss.UserType);
    sessionStorage.setItem('Time', new Date());
    localStorage.removeItem('id_admin_token');
    localStorage.removeItem('OrganizationID');
    localStorage.removeItem('userid_token');
    localStorage.removeItem('UserID');
    
    
}
    render() {
        return (<div>
            <SuperAdminLoginComponent
                superAdminLogin={this.superAdminLogin}
                loginDetails={this.props.login}
                currentEvent={this.state.currentEvent}
                setLanguage={this.setLanguage}
                GetCompanyBrandingData={this.getCompanyBrandingData1}
                activateAuthApp1={this.activateAuthApp}
                setCommonAuthenticatorMethod={this.setCommonAuthenticatorMethod}
                setVerifyEmailSMSOTP={this.setVerifyEmailSMSOTP}
                setVerifyCode={this.setVerifyCode}
            >

            </SuperAdminLoginComponent>
        </div>)

    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            superAdminLogin,
            logOutAdmin,
            setTranslateLang,
            getTranslateLang,
            getCompanyBrandingList,
            getQRCodeForAuthRegistration,
            getActivateAuthAppUser,
            getCommonAuthenticatorMethod,getVerifyEmailSMSOTP,getVerifyCode
        },
            dispatch)
    };
}

function mapStateToProps({ superAdminLoginReducer }) {
    console.log('hh', superAdminLoginReducer)
    return {
        login: {
            userName: superAdminLoginReducer.userName,
            isLoading: superAdminLoginReducer.isLoading,
            password: superAdminLoginReducer.password,
            Message: superAdminLoginReducer.Message,
            loginStatus: superAdminLoginReducer.loginStatus,
            authTokenId: superAdminLoginReducer.authTokenId,
            adminId: superAdminLoginReducer.adminId,
            brandList: superAdminLoginReducer.brandList,
            authAppUser: superAdminLoginReducer.authAppUser,
            activateAppUserSucceeded: superAdminLoginReducer.activateAppUserSucceeded,
            loginDetailss: superAdminLoginReducer.loginDetails,
            removeAccountObject:superAdminLoginReducer.removeAccountObject,
            EisCodeVerified:superAdminLoginReducer.EisCodeVerified,
            VisCodeVerified:superAdminLoginReducer.VisCodeVerified

   
        }
    }
};
export default withNamespaces()(withRouter(connect(mapStateToProps, mapDispatchToProps)(SuperAdminLoginContainer)))
